import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Process from './components/Process';
import About from './components/About';
import Testimonials from './components/Testimonials';
import ServiceArea from './components/ServiceArea';
import FAQ from './components/FAQ';
import Gallery from './components/Gallery';
import ConsultationForm from './components/ConsultationForm';
import SpecialOffer from './components/SpecialOffer';
import CTASection from './components/CTASection';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <Hero />
      <TrustBar />
      <Services />
      <WhyChooseUs />
      <Process />
      <About />
      <Testimonials />
      <ServiceArea />
      <CTASection />
      <Gallery />
      <SpecialOffer />
      <FAQ />
      <ConsultationForm />
      <Footer />
    </div>
  );
}